import { supabase } from './supabase';

// Streak milestone thresholds and their toast messages
const MILESTONES = {
  3:   '🔥 3-day streak! You\'re building a habit!',
  7:   '🔥 7-day streak! You\'re on fire!',
  14:  '🔥 14-day streak! Outstanding consistency!',
  30:  '🔥 30-day streak! You\'re a true learner!',
  60:  '🔥 60-day streak! Incredible dedication!',
  100: '🔥 100-day streak! You\'re a BiteLearning Legend!',
};

/**
 * Call after every successful lesson.
 * Reads the user's last_lesson_date, increments or resets the streak, saves it.
 * Returns { streak, longestStreak, milestoneMessage } or null on error.
 */
export async function updateStreak(userId) {
  if (!userId) return null;

  try {
    const { data: profile, error } = await supabase
      .from('user_profiles')
      .select('current_streak, longest_streak, last_lesson_date')
      .eq('id', userId)
      .single();

    if (error) throw error;

    const now       = new Date();
    const today     = now.toISOString().split('T')[0];                          // YYYY-MM-DD
    const yesterday = new Date(now - 86_400_000).toISOString().split('T')[0];  // YYYY-MM-DD

    const lastDate  = profile?.last_lesson_date;
    let newStreak   = profile?.current_streak || 0;
    let longest     = profile?.longest_streak || 0;

    if (lastDate === today) {
      // Already learned today — no change to streak
      return { streak: newStreak, longestStreak: longest, milestoneMessage: null };
    } else if (lastDate === yesterday) {
      // Consecutive day — increment
      newStreak = newStreak + 1;
    } else {
      // Missed a day (or first-ever lesson) — reset
      newStreak = 1;
    }

    if (newStreak > longest) longest = newStreak;

    await supabase
      .from('user_profiles')
      .update({
        current_streak:   newStreak,
        longest_streak:   longest,
        last_lesson_date: today,
      })
      .eq('id', userId);

    const milestoneMessage = MILESTONES[newStreak] || null;
    return { streak: newStreak, longestStreak: longest, milestoneMessage };
  } catch (err) {
    console.error('[updateStreak]', err.message);
    return null;
  }
}
